<template>
  <div class="d-inline-block">
    <v-dialog
      v-model="dialog"
      max-width="500"
      v-if="type == 'locations'"
      scrollable
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          x-small
          icon
          v-bind="attrs"
          v-on="on"
          class="mx-1"
          ><v-icon color="primary">mdi-information-outline</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title
          class="headline orangeCardTitle d-flex flex-row justify-space-between"
          ><div>Uveitis Locations Definitions</div>
          <v-btn icon small @click="dialog = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text class="darkerCardText">
          <div
            v-for="location in data.locations"
            :key="location.id"
            class="my-3"
          >
            <div class="title">{{ location.name | titleize }}</div>
            <hr class="mb-2" />

            <vue-markdown>{{ location.description }}</vue-markdown>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog"
      max-width="500"
      v-if="type == 'lab' && slug"
      scrollable
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn small text v-bind="attrs" v-on="on" class="mr-1">
          {{ data.labs[slug].name
          }}<v-icon color="primary" class="ml-2" small
            >mdi-information-outline</v-icon
          >
        </v-btn>
      </template>
      <v-card>
        <div class="orangeCardTitle d-flex flex-row justify-space-between pa-3">
          <div>
            <div class="headline">{{ data.labs[slug].name }}</div>

            <div v-if="data.labs[slug].subtitle">
              {{ data.labs[slug].subtitle }}
            </div>
          </div>
          <v-btn icon small @click="dialog = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </div>
        <v-card-text class="darkerCardText py-4">
          <vue-markdown>{{ data.labs[slug].description }}</vue-markdown>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog"
      max-width="500"
      v-if="type == 'dz' && slug"
      scrollable
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn small text v-bind="attrs" v-on="on" class="mr-1">
          {{ data.labs[slug].name }}
          <v-icon color="primary" class="ml-2" small
            >mdi-information-outline</v-icon
          >
        </v-btn>
      </template>
      <v-card>
        <div class="orangeCardTitle d-flex flex-row justify-space-between pa-3">
          <div>
            <div class="headline">{{ data.labs[slug].name }}</div>

            <div v-if="data.labs[slug].subtitle">
              {{ data.labs[slug].subtitle }}
            </div>
          </div>
          <v-btn icon small @click="dialog = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </div>
        <v-card-text class="darkerCardText py-4">
          <vue-markdown>{{ data.labs[slug].description }}</vue-markdown>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog"
      max-width="500"
      v-if="type == 'lab_group' && slug"
      scrollable
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn small text v-bind="attrs" v-on="on" class="mr-1">
          {{ data.labGroups[slug].name }}
          <v-icon color="primary" class="ml-2" small
            >mdi-information-outline</v-icon
          >
        </v-btn>
      </template>
      <v-card>
        <div class="orangeCardTitle d-flex flex-row justify-space-between pa-3">
          <div>
            <div class="headline">{{ data.labGroups[slug].name }}</div>
          </div>
          <v-btn icon small @click="dialog = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </div>
        <v-card-text class="darkerCardText py-4">
          <vue-markdown>{{ data.labGroups[slug].description }}</vue-markdown>

          <div>
            <div v-for="lab in data.labGroups[slug].labs" :key="lab">
              <uveitis-dialogs
                type="lab"
                :slug="lab"
                :data="data"
              ></uveitis-dialogs>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueMarkdown from "@adapttive/vue-markdown";

export default {
  name: "UveitisDialogs",
  components: {
    VueMarkdown,
    UveitisDialogs: () => import(".//UveitisDialogs"),
  },
  props: {
    type: null,
    data: null,
    slug: null,
  },
  data: function () {
    return {
      dialog: false,
    };
  },
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
